import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import { useEffect, useState } from 'react'
import BulbIcon from '../../Icons/Bulb'
import styles from './MUICard.module.scss'
import { MANAGE_TIPS } from '../../../Constants/ApiDefinations'
import mainApiService from '../../../Services'
import { getSanitizedValue } from '../../../Helpers/Util'
import HTTP_STATUS_CODE from '../../../Constants/HttpStatusCode'

interface MUICardTipsModal {
  module?: string
  pageType?: string
  page?: any // For the metacategory uses
}

/**
 * MUITipsCard Component displays a card with tips.
 *
 * @component
 * @example
 * // Example usage of MUITipsCard:
 * <MUITipsCard
 *   tipsArr={['Tip 1', 'Tip 2']}
 * />
 *
 * // Example usage of MUITipsCard:
 * <MUITipsCard
 *   module="ExampleModule"
 *   pageType="ExamplePageType"
 * />
 *
 * // Example usage of MUITipsCard:
 * <MUITipsCard
 *   module="ExampleModule"
 *   pageType="ExamplePageType"
 *   page="ExamplePage"
 * />
 *
 * @param {Object} props - The properties of the MUITipsCard component.
 * param {Array<string>} [props.tipsArr=[]] - An array of tips to display.
 * @param {string} [props.module] - The module for which the tips are displayed.
 * @param {string} [props.pageType] - The page type for which the tips are displayed.
 * @param {string} [props.page] - The specific page for which the tips are displayed.
 *
 * @returns {React.Element} The rendered MUITipsCard component.
 */
const MUITipsCard = ({ module, pageType, page }: MUICardTipsModal) => {
  const [tooltipsData, setTooltipsData] = useState<any>('')

  useEffect(() => {
    getTipsBasedOnPages()
  }, [module, pageType, page])

  const getTipsBasedOnPages = async () => {
    const requestedData = MANAGE_TIPS.TIPS_LIST(page)
    const result: any = await mainApiService(requestedData)

    if (result?.responseCode === HTTP_STATUS_CODE.OK) {
      const data = result?.data?.records?.[0]?.description
      setTooltipsData(data)
    }
  }

  return (
    <Card className={`${styles.tipContainer}`} sx={{ width: 250 }} data-testid='tips-card'>
      <CardContent className={`${styles.tipCardMain}`}>
        <div className={`${styles.cardHeader}`}>
          <BulbIcon />
          <p className={'sub-heading-4'}>Tips</p>
        </div>
        {tooltipsData && tooltipsData.length > 0 ? (
          <div
            className='sub-heading-6 view__role-list  text-left col36 word-wrap content-container'
            style={{ position: 'relative', right: '6px' }}
            dangerouslySetInnerHTML={{ __html: getSanitizedValue(tooltipsData) }}
          ></div>
        ) : (
          <div className='pt-1 w-100'>
            <p>No tooltip available!</p>
          </div>
        )}
      </CardContent>
    </Card>
  )
}
export default MUITipsCard
